module.exports = __webpack_public_path__ + "static/media/seguros.87341cb4.jpg";